import { fromJS, Map } from 'immutable';
import ACTIONS from './actions';

const initialState = new Map();

function reducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_GLOBAL_SETTINGS:
      return state.merge(fromJS(action.settings || {}));
    case ACTIONS.LIST_GLOBAL_SETTINGS.success:
      return fromJS(action.response.data || {});
    default:
      return state;
  }
}

// Selectors

export function hasSetting(state, key) {
  return state.has(key);
}

export function getSetting(state, key, notSetValue = undefined) {
  return state.get(key, notSetValue);
}

export default reducer;
